module.exports = __webpack_public_path__ + "static/img/label-02.82cebbb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/global_assets/images/shipping-label/system/label-02.png
// module id = 5Xpa
// module chunks = 31